import { render, staticRenderFns } from "./BatchLevelPricingForm.template.vue?vue&type=template&id=7a827ba6&scoped=true&"
var script = {}
import style0 from "./BatchLevelPricingForm.template.vue?vue&type=style&index=0&id=7a827ba6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a827ba6",
  null
  
)

export default component.exports